/* global attachEvent */

// *******************************************************************************
// 1.0 - Close Modal
// *******************************************************************************

attachEvent('.membership-card', 'click', (ev) => {
  ev.preventDefault();
  const parentMembershipCardElem = ev.target.closest('.membership-card-wrapper');
  parentMembershipCardElem.querySelector('.modal').classList.add('is-open-modal');
});
